// shared/api/identity-verification/index.ts

import { apiInstance } from "shared/api";
import { IdentityVerificationResponse } from "./types";

export const getIdentityVerification =
  (): Promise<IdentityVerificationResponse> => {
    return apiInstance
      .get(`/v1/me/identity-verification`)
      .then((response) => response.data);
  };

/** ИИН передаётся всегда: без ИИН в профиле он обязателен, с ним — может отличаться. */
export const startIdentityVerification = (
  return_to: "main" | "auth",
  iin: string,
): Promise<IdentityVerificationResponse> => {
  return apiInstance
    .post(`/v1/me/identity-verification`, null, {
      params: { return_to, iin },
    })
    .then((response) => response.data);
};
